/**
 * Feature-illustratie – Hammer+checklist, grafiek, of export
 */
interface FeatureIllustrationProps {
  variant?: 'berekeningen' | 'offerte' | 'renovatie' | 'export';
  className?: string;
}

const FEATURE_SOURCES = {
  berekeningen: '/assets/feature-berekeningen.png',
  offerte: '/assets/feature-offerte.png',
  renovatie: '/assets/feature-renovatie.png',
  export: '/assets/feature-export.png',
} as const;

const FEATURE_ALT: Record<keyof typeof FEATURE_SOURCES, string> = {
  berekeningen: 'Illustratie: bouwkosten en berekeningen met normen en materialen in CalqTool',
  offerte: 'Illustratie: offerte en begroting genereren vanuit dezelfde calculatie',
  renovatie: 'Illustratie: renovatie, transformatie en woningsplitsing in één dossier',
  export: 'Illustratie: export naar CSV, Excel en PDF vanuit rapportage',
};

export function FeatureIllustration({ variant = 'berekeningen', className = '' }: FeatureIllustrationProps) {
  return (
    <img
      src={FEATURE_SOURCES[variant]}
      alt={FEATURE_ALT[variant]}
      className={className}
      style={{ objectFit: 'contain' }}
      loading="lazy"
      decoding="async"
    />
  );
}
